'use client';
import { useState, useEffect } from 'react';
import { isFunction } from '@s7/utils';

/**
 * Проверяет срабатывание autofill на элементе.
 *
 * @param {HTMLElement} element
 */ function useIsAutofill(element) {
    var _useState = useState(false), isAutofill = _useState[0], setIsAutofill = _useState[1];
    useEffect(function() {
        var onAnimationStart = function(event) {
            if (event.animationName.includes("onautofillstart")) {
                setIsAutofill(true);
            } else {
                setIsAutofill(false);
            }
        };
        if (element) {
            // IMaskInput workaround - https://github.com/uNmAnNeR/imaskjs/issues/163
            if (!isFunction(element.addEventListener)) {
                return;
            }
            element.addEventListener("animationstart", onAnimationStart, true);
            return function() {
                element.removeEventListener("animationstart", onAnimationStart, true);
            };
        }
    }, [
        element
    ]);
    return {
        isAutofill: isAutofill
    };
}

export { useIsAutofill };
